/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TechnicalAccountList } from '../../models/technical-account-list';

export interface GetAllTechnicalAccounts$Params {
}

export function getAllTechnicalAccounts(http: HttpClient, rootUrl: string, params?: GetAllTechnicalAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<TechnicalAccountList>> {
  const rb = new RequestBuilder(rootUrl, getAllTechnicalAccounts.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TechnicalAccountList>;
    })
  );
}

getAllTechnicalAccounts.PATH = '/technical-accounts';
